import {
  removeAllVuePreloadHiddenClasses,
  removeAllVuePostloadHiddenElements
} from './util';

import './components/customer-details';
import './components/confirmation';

removeAllVuePreloadHiddenClasses('#as_customer_details');
removeAllVuePostloadHiddenElements('#as_customer_details');
removeAllVuePreloadHiddenClasses('#as_confirmation');
removeAllVuePostloadHiddenElements('#as_confirmation');
